const compareStrings = (a, b, order) => {
  // eslint-disable-next-line no-undefined
  const compareResult = a.localeCompare(b, undefined, {
    sensitivity: "base"
  });

  if (order === "desc") {
    return compareResult * -1;
  }

  return compareResult;
};

const compareEverything = (a, b, order) => {
  if (order === "desc") {
    return b - a;
  }

  return a - b;
};
/**
 * It returns the correct compare function based on the Object's property type
 * @param  {String} property Object's property name to compare
 * @param  {String} order    "asc" or "desc"
 * @return {[type]}          [description]
 */


const compareObjectByProperty = (property, order) => (a, b) => {
  const aValue = a[property] || "";
  const bValue = b[property] || "";
  let compareFunction = compareEverything;

  if (typeof bValue === "string" && typeof aValue === "string") {
    compareFunction = compareStrings;
  }

  return compareFunction(aValue, bValue, order);
};
/**
 * Sorts any kind(Strings, Numbers, Dates, etc.) of data.
 *
 * @public
 * @param  {Array} data Array of objects
 * @param  {String} sortBy Object property to sort by
 * @param  {String} direction "asc" or "desc"
 * @return {Array} A new Array containing the sorted items.
 *  The original Array will not be modified.
 */


export default ((data, sortBy, direction) => {
  const compareFunction = compareObjectByProperty(sortBy, direction);
  return [...data].sort(compareFunction);
});